var MAX_DURATION_LENGTH = 80;
var MAX_STEP_NAME_LENGTH = 500;
var EXCLUDED_JOURNEY_TYPES = ['WELCOME', 'CONFIRMATION', 'SUCCESS', 'RESULT'];
var isRecord = function (value) { return typeof value === 'object' && value !== null; };
var isUnknownArray = function (value) { return Array.isArray(value); };
var isSafePositiveInteger = function (value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value && value > 0 && value <= 9007199254740991;
};
var getDuration = function (step) {
    var candidates = [step.duration, step.estimatedDuration, step.estimatedTime];
    for (var index = 0; index < candidates.length; index += 1) {
        var duration = candidates[index];
        if (typeof duration !== 'string')
            continue;
        var trimmedDuration = duration.trim();
        if (trimmedDuration && trimmedDuration.length <= MAX_DURATION_LENGTH)
            return trimmedDuration;
    }
    return undefined;
};
/**
 * Builds optional journey metadata only when the backend form describes a
 * complete, unambiguous sequence. It never infers a step from its array index.
 */
export var getWelcomePresentation = function (form, currentStep) {
    if (!isRecord(form) || !isRecord(currentStep))
        return null;
    var countSteps = form.countSteps;
    var steps = form.steps;
    var currentStepNumber = currentStep.step;
    if (!isSafePositiveInteger(countSteps) ||
        !isUnknownArray(steps) ||
        steps.length !== countSteps ||
        !isSafePositiveInteger(currentStepNumber)) {
        return null;
    }
    var seenSteps = {};
    var verifiedSteps = [];
    var currentStepFound = false;
    for (var index = 0; index < steps.length; index += 1) {
        var candidate = steps[index];
        if (!isRecord(candidate) || !isSafePositiveInteger(candidate.step) || candidate.step > countSteps) {
            return null;
        }
        var stepKey = String(candidate.step);
        if (seenSteps[stepKey])
            return null;
        seenSteps[stepKey] = true;
        verifiedSteps.push({ data: candidate, step: candidate.step });
        if (candidate === currentStep && candidate.step === currentStepNumber) {
            currentStepFound = true;
        }
    }
    if (!currentStepFound)
        return null;
    verifiedSteps.sort(function (left, right) { return left.step - right.step; });
    var journey = [];
    for (var index = 0; index < verifiedSteps.length && journey.length < 3; index += 1) {
        var candidate = verifiedSteps[index];
        var data = candidate.data, step = candidate.step;
        var showStepName = data.showStepName, stepName = data.stepName, type = data.type;
        if (step <= currentStepNumber ||
            showStepName !== true ||
            typeof stepName !== 'string' ||
            typeof type !== 'string' ||
            EXCLUDED_JOURNEY_TYPES.indexOf(type) >= 0) {
            continue;
        }
        var name_1 = stepName.trim();
        if (!name_1 || name_1.length > MAX_STEP_NAME_LENGTH)
            continue;
        journey.push({ duration: getDuration(data), name: name_1, step: step });
    }
    return {
        currentStep: currentStepNumber,
        journey: journey,
        totalSteps: countSteps,
    };
};
